<template>
  <div>
    <section class="card mt-4">
      <b-card-header
        header="Categorias"
        header-text-variant="white"
        :style="cor"
      />
      <b-card class="shadow">
        <b-card-text class="pt-0 table">
          <b-table :items="pRelatorioGerencialDados.porCategoria" :fields="fieldsCategoria" v-if="pRelatorioGerencialDados.porCategoria && pRelatorioGerencialDados.porCategoria.length > 0"></b-table>
          <span v-else>
            Não há itens para este filtro
          </span>
        </b-card-text>
        <div slot="footer" class="footer" v-if="pRelatorioGerencialDados.porCategoria && pRelatorioGerencialDados.porCategoria.length > 0">Total: R$ {{this.formatterValue(totalCategoria)}}</div>
      </b-card>
    </section>
    <section class="card mt-4" v-if="representantes.length > 1">
      <b-card-header
        header="Representante"
        header-text-variant="white"
        :style="cor"
      />
      <b-card class="shadow">
        <b-card-text class="pt-0 table">
          <b-table :items="pRelatorioGerencialDados.porRepresentate" :fields="fieldsRepresentante" v-if="pRelatorioGerencialDados.porRepresentate && pRelatorioGerencialDados.porRepresentate.length > 0"></b-table>
          <span v-else>
            Não há itens para este filtro
          </span>
        </b-card-text>
        <div slot="footer" class="footer" v-if="pRelatorioGerencialDados.porRepresentate && pRelatorioGerencialDados.porRepresentate.length > 0">Total: R$ {{this.formatterValue(totalRepresentante)}}</div>
      </b-card>
    </section>
    <section class="card mt-4">
      <b-card-header
        header="Clientes"
        header-text-variant="white"
        :style="cor"
      />
      <b-card class="shadow">
        <b-card-text class="pt-0 table">
          <b-table :items="pRelatorioGerencialDados.porCliente" :fields="fieldsCliente" v-if="pRelatorioGerencialDados.porCliente && pRelatorioGerencialDados.porCliente.length > 0"></b-table>
          <span v-else>
            Não há itens para este filtro
          </span>
        </b-card-text>
        <div slot="footer" class="footer" v-if="pRelatorioGerencialDados.porCliente && pRelatorioGerencialDados.porCliente.length > 0">Total: R$ {{this.formatterValue(totalCliente)}}</div>
      </b-card>
    </section>
    <section class="card mt-4">
      <b-card-header
        header="UF"
        header-text-variant="white"
        :style="cor"
      />
      <b-card class="shadow">
        <b-card-text class="pt-0 table">
          <b-table :items="pRelatorioGerencialDados.porUFCliente" :fields="fieldsUF" v-if="pRelatorioGerencialDados.porUFCliente && pRelatorioGerencialDados.porUFCliente.length > 0"></b-table>
          <span v-else>
            Não há itens para este filtro
          </span>
        </b-card-text>
        <div slot="footer" class="footer" v-if="pRelatorioGerencialDados.porUFCliente && pRelatorioGerencialDados.porUFCliente.length > 0">Total: R$ {{this.formatterValue(totalUF)}}</div>
      </b-card>
    </section>
    <section class="card mt-4">
      <b-card-header
        header="Diário"
        header-text-variant="white"
        :style="cor"
      />
      <b-card class="shadow">
        <b-card-text class="pt-0 table">
          <b-table :items="pRelatorioGerencialDados.porDia" :fields="fieldsDiario" v-if="pRelatorioGerencialDados.porDia && pRelatorioGerencialDados.porDia.length > 0"></b-table>
          <span v-else>
            Não há itens para este filtro
          </span>
        </b-card-text>
        <div slot="footer" class="footer" v-if="pRelatorioGerencialDados.porDia && pRelatorioGerencialDados.porDia.length > 0">Total: R$ {{this.formatterValue(totaDia)}}</div>
      </b-card>
    </section>

    <!--&lt;!&ndash; TESTE DE TABELA COM ACCORDION -&ndash;&gt;-->
    <!--<section class="mt-4 card">-->
      <!--<b-card-header-->
        <!--header="czxcz"-->
        <!--header-text-variant="white"-->
        <!--:style="cor"-->
      <!--/>-->
      <!--<b-card class="shadow">-->
        <!--<b-card-text class="pt-0">-->
          <!--<b-table-->
            <!--ref="taskAssignmentTable"-->
            <!--striped hover responsive show-empty-->
            <!--primary-key="_rowIndex"-->
            <!--:items="flattenedTree"-->
            <!--:fields="fields"-->
            <!--:filter="filterObj"-->
            <!--:filter-function="_filterFunction">-->
            <!--&lt;!&ndash;               &ndash;&gt;-->
            <!--&lt;!&ndash; COLUMN A data &ndash;&gt;-->
            <!--&lt;!&ndash;               &ndash;&gt;-->
            <!--<template slot="columnA" slot-scope="data">-->
              <!--<template v-if="data.item._hasChildren">-->
                <!--&lt;!&ndash; COLUMN A has children - indent content and add a toggler button &ndash;&gt;-->
                <!--<span :style="`margin-left: ${(data.item._rowDepth * 1.5)}em`">-->
                  <!--<b-button size="sm" variant="secondary" class="left col-1" @click="_toggleRowExpansion(data.item)">-->
                    <!--{{data.item._rowIsExpanded? '-' : '+'}}-->
                  <!--</b-button>-->
                  <!--{{ data.item.columnA }}-->
                <!--</span>-->
              <!--</template>-->
              <!--<template v-else>-->
                <!--&lt;!&ndash; COLUMN A has no children - just indent the content &ndash;&gt;-->
                <!--<span :style="`margin-left:${(data.item._rowDepth * 1.5) + 1.5}em`">-->
                  <!--{{ data.item.columnA }}-->
                <!--</span>-->
              <!--</template>-->
            <!--</template>-->
            <!--&lt;!&ndash;               &ndash;&gt;-->
            <!--&lt;!&ndash; COLUMN B data &ndash;&gt;-->
            <!--&lt;!&ndash;               &ndash;&gt;-->
            <!--<template slot="columnB" slot-scope="data">{{ data.item.columnB }}</template>-->
            <!--&lt;!&ndash;               &ndash;&gt;-->
            <!--&lt;!&ndash; COLUMN C data &ndash;&gt;-->
            <!--&lt;!&ndash;               &ndash;&gt;-->
            <!--<template slot="columnC" slot-scope="data">{{ data.item.columnC }}</template>-->
          <!--</b-table>-->
          <!--<b-button @click="teste">teste</b-button>-->
        <!--</b-card-text>-->
      <!--</b-card>-->
    <!--</section>-->
    <!--<b-button-group>-->
      <!--<b-btn size="sm" @click="_expandAll(true)">Expand All</b-btn>-->
      <!--<b-btn size="sm" @click="_collapseAll(false)">Collapse All</b-btn>-->
    <!--</b-button-group>-->
    <!--&lt;!&ndash; FIM DE TESTE DE TABELA COM ACCORDION &ndash;&gt;-->
  </div>
</template>
<script>
  import ToastVue from '../layouts/toastVue'
  import spinnerVue from '@/components/items/SpinnerVue'

  var ROW_INDEX = 0

  export default {
    props: {
      pRelatorioGerencialDados: {}
    },
    data () {
      return {
        blockUI: {
          message: '',
          visibility: false
        },
        message: [{
          idToast: 'my-toast',
          titleMsg: '',
          message: '',
          variant: ''
        }],
        representantes: [],
        totalCategoria: 0.00,
        totalRepresentante: 0.00,
        totalCliente: 0.00,
        totalUF: 0.00,
        totaDia: 0.00,
        fieldsCategoria: [
          {
            key: 'categoria',
            label: 'Categoria',
            sortable: false,
            class: 'txtLeft',
            formatter: this.toCapitalize
          },
          {
            key: 'valor',
            label: 'Valor',
            sortable: false,
            class: 'txtRight',
            formatter: this.formatterValue
          }
        ],
        fieldsRepresentante: [
          {
            key: 'nome',
            label: 'Nome',
            sortable: false,
            class: 'txtLeft',
            formatter: this.toCapitalize
          },
          {
            key: 'valor',
            label: 'Valor',
            sortable: false,
            class: 'txtRight',
            formatter: this.formatterValue
          }
        ],
        fieldsCliente: [
          {
            key: 'nome',
            label: 'Fantasia',
            sortable: false,
            class: 'txtLeft',
            formatter: this.toCapitalize
          },
          {
            key: 'valor',
            label: 'Valor',
            sortable: false,
            class: 'txtRight',
            formatter: this.formatterValue
          }
        ],
        fieldsUF: [
          {
            key: 'uf',
            label: 'UF',
            sortable: false,
            class: 'txtLeft'
          },
          {
            key: 'valor',
            label: 'Valor',
            sortable: false,
            class: 'txtRight',
            formatter: this.formatterValue
          }
        ],
        fieldsDiario: [
          {
            key: 'emissao',
            label: 'Data',
            sortable: false,
            class: 'txtLeft'
          },
          {
            key: 'valor',
            label: 'Valor',
            sortable: false,
            class: 'txtRight',
            formatter: this.formatterValue
          }
        ],
        components: {
          spinnerVue,
          ToastVue
        }
      }
    },
    created () {
      this.cor = {'background-color': `#${localStorage.getItem('corApp')}`}
      this.representantes = JSON.parse(localStorage.getItem('representantesLogin'))
    },
    watch: {
      pRelatorioGerencialDados: function (newVal, oldVal) { // watch it
        this.totalCategoria = newVal.porCategoria.reduce(function (r, a) { return r + a.valor }, 0)
        // REPRESENTANTE
        this.totalRepresentante = newVal.porRepresentate.reduce(function (r, a) { return r + a.valor }, 0)
        // CLIENTE
        this.totalCliente = newVal.porCliente.reduce(function (r, a) { return r + a.valor }, 0)
        // UF
        this.totalUF = newVal.porUFCliente.reduce(function (r, a) { return r + a.valor }, 0)
        // DIA
        this.totaDia = newVal.porDia.reduce(function (r, a) { return r + a.valor }, 0)
      }
    },
    computed: {
      flattenedTree () {
        return this._flattenTreeStructure(this.tree)
      }
    },
    methods: {
      teste: function () {
        console.log(JSON.stringify(this.tree))
        this.tree[0].children = [{
          columnA: 'filho jhon',
          columnB: 'filho Smith',
          columnC: '150'
        }]
        console.log(JSON.stringify(this.tree))
        this.flattenedTree()
      },
      _toggleRowExpansion (row) {
        if (row._hasChildren) {
          row._rowIsExpanded = !row._rowIsExpanded
          this.$set(this.filterObj.expandedRowIndices, row._rowIndex, row._rowIsExpanded)
        }
      },
      _expandAll () {
        this._collapseOrExpandAll(true)
      },
      _collapseAll () {
        this._collapseOrExpandAll(false)
      },
      _collapseOrExpandAll (doExpand) {
        let vm = this
        this.flattenedTree.filter(row => row._hasChildren).forEach((row) => {
          row._rowIsExpanded = doExpand
          vm.$set(vm.filterObj.expandedRowIndices, row._rowIndex, doExpand)
        })
      },
      _filterFunction (row, filter) {
        if (row._rowDepth === 0) {
          return true
        }
        let shouldExpand = true
        let currentRow = row
        while (shouldExpand && currentRow._rowParent !== null) {
          shouldExpand = shouldExpand && filter.expandedRowIndices[currentRow._rowParent._rowIndex] === true
          currentRow = currentRow._rowParent
        }
        return shouldExpand
      },
      _flattenTreeStructure (rows, parentRow = null, depth = 0) {
        let result = []
        for (let idx = 0; idx < rows.length; idx++) {
          let row = rows[idx]
          result.push(row)
          row._rowDepth = depth
          row._rowIsExpanded = false
          row._rowParent = parentRow
          row._rowIndex = ROW_INDEX
          ROW_INDEX++
          if (row.children && row.children.length > 0) {
            row._hasChildren = true
            let children = row.children
            let flattenedChildren = this._flattenTreeStructure(children, row, depth + 1)
            result = [...result, ...flattenedChildren]
          }
        }
        return result
      },
      formatterValue: function (valor) {
        let val = (valor / 1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      },
      toCapitalize: function (value) {
        return value.replace(/\w\S*/g, function (txt) {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
        })
      }
    }
  }
</script>
<style scoped>
  .table {
    overflow-y: scroll;
    position: relative;
    min-height: 82px;
    max-height: 210px;
    font-size: 14px;
  }
  .imgTable {
    width: 50px !important;
  }
  .footer {
    font-weight: 900;
    text-align: right;
  }
  /*@media (max-height: 145px) {*/
    /*.table {*/
      /*overflow-y: hidden;*/
    /*}*/
  /*}*/
</style>



// WEBPACK FOOTER //
// src/components/items/relatorioGerencialVue.vue